import React, { FC, memo } from "react";

import { Tooltip } from "@epignosis_llc/gnosis";

import { useApplyTranslations } from "@hooks";

import { GenericActionType } from "@components/CustomTable/components/TableActions/GenericAction/types";
import { ActionGhostButton } from "@components/ReusableComponents";

import { actionMap } from "./constants";

const GenericAction: FC<GenericActionType> = ({
  actionType,
  tooltipContent,
  entity,
  iconHeight,
  icon,
  disabled = false,
  permissions = [],
  onClick,
}) => {
  const { t } = useApplyTranslations();
  const { icon: Icon, height, testId } = actionMap[actionType];
  const DisplayedIcon = icon || Icon;

  const defaultTooltip = t(`general.actions.${actionType}`);
  const ariaLabel = t(`general.actions.${actionType}Entity`, { entity });

  const canShow = permissions?.every(Boolean);
  if (!canShow) return null;

  return (
    <Tooltip
      content={tooltipContent ?? defaultTooltip}
      parentProps={{ "aria-label": tooltipContent ?? defaultTooltip }}
    >
      <ActionGhostButton
        disabled={disabled}
        onClick={onClick}
        data-testid={testId}
        aria-label={ariaLabel}
      >
        <DisplayedIcon height={iconHeight ?? height} />
      </ActionGhostButton>
    </Tooltip>
  );
};

export default memo(GenericAction);
